<template>
  <div>
    <!-- <Breadcrumb :options="breadcrumb" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="false" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "CustomerCarrier",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'pcustom',
      breadcrumb: [
        { name: "承运管理" },
        { name: "承运商管理" },
      ],
      formInline: {
        is_status: '在用',
      },
      baseParams: ['is_status'],
      formCtrl: [
        {
          label: "公司名称",
          keyName: "company",
          placeholder: "请填写公司名称",
          type: "text",
        },
        // {
        //   label: "承运联系人",
        //   keyName: "pname",
        //   placeholder: "请填写承运联系人姓名",
        //   type: "text",
        // },
      ],
      title: '承运商添加',
      mform: {
        pname: '',
        company: '',
        phone: '',
        address: '',
        is_status: '在用',
      },
      mrules: {
        pname: [
          {
            required: true,
            message: '请填写承运联系人姓名',
            trigger: 'blur',
          }
        ],
        company: [
          {
            required: true,
            message: '请填写公司名称',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请填写地址',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "公司名称",
          keyName: "company",
          err: "请填写公司名称",
          type: "text",
        },
        {
          label: "承运联系人",
          keyName: "pname",
          err: "请填写承运联系人姓名",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
          //className:'de-adsu',
        },
        {
          label: "地址",
          keyName: "address",
          err: "请填写地址",
          type: "text",
        },
        {
          label: "承运商状态",
          keyName: "is_status",
          type: "select",
          options: [
            { label: '在用', value: '在用' },
            { label: '停用', value: '停用' },
          ],
        },
      ],
      cols: [
        { keyName: "company", label: "公司名称", minwidth: 150 },
        { keyName: "address", label: "公司地址", minwidth: 200 },
        { keyName: "pname", label: "承运联系人", minwidth: 120 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "carcount", label: "车辆总数", minwidth: 100 },
      ],
      btns: [
        {
          class: 'viewlistbtn',
          title: '查看列表',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ company, id }) => {
            // console.log(id)
            this.$router.push({
              path: `/carrier/carlist`,
              query: {
                company,
                id,
              }
            })
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            console.log(id);
            this.title = "修改承运商";
            this.getData(id);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
    };
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      console.log(this.$route.params)
      // const { idx } = this.$route.params
      // this.formInline.iswork = iswork || 1
      // this.page = 1
      this.getParams()
      // console.log(iswork)
    },
  },
  methods: {
    getParams() {
      const { idx } = this.$route.params

      this.formInline.is_status = idx == 1 ? '在用' : '停用'

      this.getList()
    },
    addItem() {
      this.title = '添加承运商'
      this.mform = {
        pname: '',
        company: '',
        phone: '',
        address: '',
        is_status: '在用',
      };
      this.showDialog();
    },
    getData(id) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
        id,
      };
      this.mform['id'] = id
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
            });
            console.log('mform', { ...this.mform })
            this.showDialog();
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
  },
  created() {
    const { user_group_id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.splice(0, 1)
    }
  },
  mounted() {
    this.getParams();
  },
};
</script>
<style scoped>
.fillet {
  height: auto;
  /* overflow: hidden; */
  margin: 0 auto;
  padding: 20px 0px 10px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
}

.retrieval {
  height: auto;
  /* overflow: hidden; */
  margin: 0px 20px;
  font-size: 14px;
  color: #606266;
}
</style>